// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BOosM","icon":"styles_icon__30DEf"};